var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79651 1.66671C7.15563 1.66671 7.51331 1.81208 7.77442 2.09832L14.1665 9.1089C14.6268 9.6138 14.6268 10.3863 14.1665 10.8912L7.77442 17.9018C7.28222 18.4416 6.44545 18.4803 5.90577 17.9881C5.36595 17.4958 5.32733 16.6593 5.81939 16.1195L11.399 10L5.81939 3.88059C5.32733 3.34078 5.36595 2.50427 5.90577 2.01194C6.15934 1.78073 6.47852 1.66671 6.79651 1.66671Z",
    fill: "#009BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowIcon);
export default __webpack_public_path__ + "static/media/sidebar-arrow-icon.ee990dfd09e42dff1fa6ae755d8d38b6.svg";
export { ForwardRef as ReactComponent };